import { render } from "./UserPermissionsManagement.vue?vue&type=template&id=3ee0e4ac"
import script from "./UserPermissionsManagement.vue?vue&type=script&lang=js"
export * from "./UserPermissionsManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__